var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66732 6H7.33398V8H5.33398V9.33333H7.33398V11.3333H8.66732V9.33333H10.6673V8H8.66732V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 3.33333H7.60998L6.47198 2.19533C6.41018 2.13331 6.33672 2.08411 6.25583 2.05059C6.17494 2.01707 6.08821 1.99987 6.00065 2H2.66732C1.93198 2 1.33398 2.598 1.33398 3.33333V12.6667C1.33398 13.402 1.93198 14 2.66732 14H13.334C14.0693 14 14.6673 13.402 14.6673 12.6667V4.66667C14.6673 3.93133 14.0693 3.33333 13.334 3.33333ZM2.66732 12.6667V4.66667H13.334L13.3353 12.6667H2.66732Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGroup);
export default __webpack_public_path__ + "static/media/createGroup.e8eed6e29086138b7a135a53a6df73c0.svg";
export { ForwardRef as ReactComponent };